import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { Button, colors } from '@material-dev/thread';
import IconButton from 'admin/components/IconButton';

import Triangle from './Triangle';
import Container from './Container';

const CloseButton = styled(IconButton).attrs({
  icon: 'close'
})`
  position: absolute;
  top: 5px;
  right: 5px;
`;

const Title = styled.h3`
  margin: 4px 20px 14px 0;
  font-size: 18px;
  font-weight: bold;
  color: ${colors.black87};
`;

const Description = styled.div`
  font-size: 14px;
  color: ${colors.black54};
`;

const Modal = ({
  title,
  description,
  confirmButtonLabel,
  secondaryButtonLabel,
  onDismissButtonClicked,
  onConfirmButtonClicked,
  onSecondaryButtonClicked,
  anchorClass
}) => (
  <Container className={anchorClass}>
    <CloseButton onClick={onDismissButtonClicked} />
    <Title>{title}</Title>
    <Description>{description}</Description>

    <Flex justifyContent={'flex-end'} alignItems={'center'} mt={3}>
      {secondaryButtonLabel && <Box mr={2}>
        <Button variant="link" onClick={onSecondaryButtonClicked}>{secondaryButtonLabel}</Button>
      </Box>}
      <Box>
        <Button variant="primary" onClick={onConfirmButtonClicked}>{confirmButtonLabel}</Button>
      </Box>
    </Flex>
    <Triangle />
  </Container>
);

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  confirmButtonLabel: PropTypes.string.isRequired,
  secondaryButtonLabel: PropTypes.string,
  anchorClass: PropTypes.string.isRequired,
  onDismissButtonClicked: PropTypes.func.isRequired,
  onConfirmButtonClicked: PropTypes.func.isRequired,
  onSecondaryButtonClicked: PropTypes.func
};

export default Modal;



// WEBPACK FOOTER //
// ./src/app/admin/components/Hotspot/Modal/index.js